import { Component } from '@angular/core';

// Fatia 5B — wrapper de rota da Creche (Espaço Criança).
// Apenas hospeda o <router-outlet> dos filhos (home = listagem/gestão).
@Component({
  selector: 'app-daycare',
  template: '<router-outlet></router-outlet>',
})
export class DaycareComponent {}
